<template>
<div class="third" :class="{'mb': wayType==='m-phone' || wayType==='m-email' || wayType===''}">
    <div class="or">
        <div class="left"></div>
        <div class="mid"><span>{{ $t($loginLangPrefix('userSign.other')) }}</span></div>
        <div class="right"></div>
    </div>
    <div class="way-wrap clear">
        <a class="way" v-for="(way, index) in loginWays" :key="index" :class="way.name" :href="way.url" @click="thirdLogin(way.name)" >
        </a>
    </div>
</div>
</template>
<script>

import logreg from './js/logreg';

export default {
    name: 'thirdwrap',
    props: {
        thirdHost: { type: String, default: '' },
        oldThirdHost: { type: String, default: '' },
        clientId: { type: String, default: '' },
        wayType: { type: String, default: '' }
    },
    data() {
        return {
            loginWays: [
                {
                    name: 'tw',
                    url: `//${this.thirdHost}/third/authorize?plat=13&display=iframe&redirect=http%3A%2F%2F${this.oldThirdHost}%2Fcgi-bin%2Flogin%3Fresponse_type%3Dcode%26client_id%3D${this.clientId}%26display%3Diframe%26geo%3Den%26redirect_uri%3D${encodeURIComponent(`${window.location.protocol}//${window.location.host}/`)}`
                }, {
                    name: 'google',
                    url: `//${this.thirdHost}/third/authorize?plat=4&display=iframe&redirect=http%3A%2F%2F${this.oldThirdHost}%2Fcgi-bin%2Flogin%3Fresponse_type%3Dcode%26client_id%3D${this.clientId}%26display%3Diframe%26geo%3Den%26redirect_uri%3D${encodeURIComponent(`${window.location.protocol}//${window.location.host}/`)}`
                }, {
                    name: 'ins',
                    url: `//${this.thirdHost}/third/authorize?plat=9&display=iframe&redirect=http%3A%2F%2F${this.oldThirdHost}%2Fcgi-bin%2Flogin%3Fresponse_type%3Dcode%26client_id%3D${this.clientId}%26display%3Diframe%26geo%3Den%26redirect_uri%3D${encodeURIComponent(`${window.location.protocol}//${window.location.host}/`)}`
                }, {
                    name: 'line',
                    url: `//${this.thirdHost}/third/authorize?plat=17&display=iframe&redirect=http%3A%2F%2F${this.oldThirdHost}%2Fcgi-bin%2Flogin%3Fresponse_type%3Dcode%26client_id%3D${this.clientId}%26display%3Diframe%26geo%3Den%26redirect_uri%3D${encodeURIComponent(`${window.location.protocol}//${window.location.host}/`)}`
                }
            ]
        };
    },

    methods: {
        thirdLogin(name) {
            logreg.thirdLogin(name);
        },
        play() {
        }
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.third {
    position: relative;
    width: 100%;
    padding-top: 40px;
    box-sizing: border-box;
    &.mb {
        position: relative;
        width: 100%;
        padding-top: 0;
        .or {
            .left {
                width: rem(136);
                right: 0;
                height: rem(1);
            }
            .mid {
                width: rem(48);
                font-size: rem(16);
                span {
                    bottom: rem(-3);
                }
            }
            .right {
                width: rem(136);
                left: 0;
                height: rem(1);
            }
        }
        .way-wrap {
            position: relative;
            width: 100%;
            margin-top: rem(26);
            height: rem(40);
            .way {
                width: rem(40);
                height: rem(40);
                margin: 0 rem(20);
                background-size: 100% 100%;
                vertical-align: top;
            }
        }
    }
    .or {
        position: relative;
        width: 100%;
        // letter-spacing: -4px;
        font-size: 0;
        .left {
            display: inline-block;
            width: 136px;
            right: 0;
            height: 1px;
            background: #E3E3E3;
        }
        .mid {
            display: inline-block;
            width: 48px;
            font-size:16px;
            font-family: 'RobotoRegular';
            font-weight: normal;
            color:rgba(23,23,23,1);
            text-align: center;
            span {
                position: relative;
                bottom: -3px;
            }
        }
        .right {
            display: inline-block;
            width: 136px;
            left: 0;
            height: 1px;
            background: #E3E3E3;
        }
    }
    .way-wrap {
        position: relative;
        width: 100%;
        margin-top: 27px;
        height: 40px;
        .way {
            display: inline-block;
            position: relative;
            vertical-align: top;
            width: 40px;
            height: 40px;
            margin: 0 20px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center center;
            &.tw {
                background-image: url('./images/Twitter.png');
            }
            &.google {
                background-image: url('./images/Google.png');
            }
            &.ins {
                background-image: url('./images/Instagram.png');
            }
            &.line {
                background-image: url('./images/line.png');
            }
        }
    }
}
</style>
